import React from 'react';
import { PinToggle } from './PinToggle';
import { baseStyles } from '../styles';
import { useSignInForm } from '../hooks/useSignInForm';
import { useAuthStep } from '../context/AuthStepContext';
import AuthActionButton from './AuthActionButton';

const PinInputForm = () => {
  const { pinUpdated } = useSignInForm();
  const { lastStep } = useAuthStep();
  return (
    <form style={baseStyles.clientReg}>
      <PinToggle
        label="Use 4-digit PIN to sign in"
        type="checkbox"
        submit={pinUpdated}
      />
      <AuthActionButton
        onClick={() => {
          lastStep();
        }}
      />
    </form>
  );
};

export default PinInputForm;
